module.exports = __webpack_public_path__ + "img/dark.4b9527ff.svg";